import React from 'react'
import { Helmet } from 'react-helmet'
import * as styles from './layout.module.css'
import NavBar from './nav-bar'
import SEO from './seo'
import Footer from './UI/footer'

const Layout = ({ pageTitle, children }) => {
  return (
    <div>
      {/* <Helmet>
        <title>Frudee Web Studio</title>
      </Helmet> */}
      <SEO />
      <header>
        <NavBar />
      </header>
      <main className={styles}>
        {children}

        <Footer />
      </main>
    </div>
  )
}

export default Layout
